import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import ServicesItem from '../../../components/ServicesItem';
import { Collapsible, CollapsibleContent, CollapsibleHeader } from '../../../components/Collapsible';
import { setCollapseContentTracking } from '../../../store/actions/dataLayer';

import { PortalConfigContext } from '../../../config/portal';

import './styles.css';
import { getMessages } from '../../../tppServices/translations/messages';

class Services extends PureComponent {

  render() {
    const { setCollapseContentTracking, intl: { formatMessage: t }, hideHeader, headerPriority } = this.props;
    const services = get(this, 'context.services.items', []);
    let classOverride = `details services-collapsible${hideHeader ? ' hide-title' : ''} `;
    const messages = getMessages();

    return (
      <CollapsibleContent initialState="open" classOverride={classOverride}>
        <CollapsibleHeader
          onClick={
            (e, open) => {
              if (open) {
                setCollapseContentTracking('services');
              }
            }
          }
          priority={headerPriority}
        >
          {t(messages.servicesDetails)}
        </CollapsibleHeader>
        <Collapsible type="no-pad">
          <div className="services">
            {services.map((item, idx) =>
              <ServicesItem
                key={idx}
                link={item.link}
                serviceIcon={item.serviceCategory}
                serviceName={item.serviceName}
                serviceTitle={t(messages.services[item.serviceCategory])}
              />
            )}
          </div>
        </Collapsible>
      </CollapsibleContent>
    );
  }
}

Services.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  /** Analytics helper  */
  setCollapseContentTracking: PropTypes.func.isRequired,
  hideHeader: PropTypes.bool,
  headerPriority: PropTypes.number,
};
Services.defaultProps = {
  hideHeader: false,
  headerPriority: 2,
};
Services.contextType = PortalConfigContext;

export default connect(null, dispatch => bindActionCreators({
  setCollapseContentTracking,
}, dispatch))(injectIntl(Services));
